// extracted by mini-css-extract-plugin
export default {"attachedDocumentWrapper":"DocumentLink_attachedDocumentWrapper__PIgpH","documentName":"DocumentLink_documentName__hjaeU","documentSize":"DocumentLink_documentSize__FIJlS"};